// extracted by mini-css-extract-plugin
module.exports = {"tile":"tile-module--tile--1VXQV"};